import React, { useState, useEffect } from "react";
import { Input, Button, Typography, Tabs } from "antd";
import {
  QuestionCircleOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { setConductTestId, changeQuestionsOfTest } from "../../../reducers/conductTest";
import { useNavigate, useSearchParams } from "react-router-dom";
import TestDetails from "./details";
import Candidates from "./candidates";
import Questions from "./questions";
import "./conducttes.css";

const { Title } = Typography;

const ConductTest = () => {
  const [localTestId, setLocalTestId] = useState("");
  const [searchParams] = useSearchParams();
  const testid = searchParams.get("testid");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const conduct = useSelector((state) => state.conductTest);
  // console.log("conductId",conduct);
  

  useEffect(() => {
    if (testid) {
      dispatch(setConductTestId(testid));
    }
  }, [dispatch, testid]);

  const handleProceed = () => {
    if (localTestId.trim()) {
      navigate(`/user/conducttest?testid=${localTestId}`);
    }
  };

  if (!conduct.id) {
    return (
      <div className="conduct-test-main-wrapper">
        <Title style={{ textAlign: "center" }} level={4}>
          Enter Test ID
        </Title>
        <div className="test-conduct-testid-form">
          <Input
            placeholder="Enter test ID"
            value={localTestId}
            onChange={(e) => setLocalTestId(e.target.value)}
          />
          <Button
            type="primary"
            onClick={handleProceed}
            style={{ marginTop: "30px" }}
          >
            Proceed
          </Button>
        </div>
      </div>
    );
  }

  if (conduct.currentTestDetails.testconducted) {
    return (
      <div className="reasendmail-container-register">
        <Title
          level={4}
          style={{ color: "#000", textAlign: "center", marginTop: "50px" }}
        >
          The test has ended! Go to all tests to check the results.
        </Title>
      </div>
    );
  }

  return (
    <div className="conduct-test-main-wrapper">
      <TestDetails />
      <Tabs
        defaultActiveKey="1"
        style={{ marginTop: "20px" }}
        items={[
          {
            key: "1",
            label: (
              <span>
                <UserOutlined style={{ marginRight: 5 }} />
                Registered Trainee
              </span>
            ),
            children: <Candidates />,
          },
          {
            key: "2",
            label: (
              <span>
                <QuestionCircleOutlined style={{ marginRight: 5 }} />
                Questions
              </span>
            ),
            children: (
              <Questions
                id={conduct.id}
                questionsOfTest={conduct.questionsOfTest}
                updateQuestiosnTest={(data) =>
                  dispatch(changeQuestionsOfTest(data))
                }
              />
            ),
          },
        ]}
      />
    </div>
  );
};

export default ConductTest;
